// Visitors who ask their OS for reduced motion get each animation once, ending on its last frame,
// rather than not at all (some start on a blank frame) or forever.
export const prefersReducedMotion =
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
